import CreateContent from "./CreateContent";

export default function CreateReel() {
  return <CreateContent type="REEL" />;
}
